import * as React from 'react'

import {logEvent} from '@lib/gtm'

import {scrollIntoView} from './utils'

export const Hero = () => {
  const handleOnClick = (
    event: React.MouseEvent<HTMLAnchorElement>,
    label: string
  ) => {
    const {hash} = event.currentTarget

    event.preventDefault()
    scrollIntoView(hash)
    logEvent({
      ga: {
        category: 'AI Consultation',
        action: `Click ${label}`,
        label: 'Header',
      },
    })
  }

  return (
    <div className='AI__hero'>
      <video className='AI__hero__video' autoPlay loop playsInline muted>
        <source src='/videos/ai.mp4' type='video/mp4' />
        Your browser does not support the video tag.
      </video>
      <div className='container'>
        <div className='AI__hero__content'>
          <h2>Transform complex data into your business' success</h2>
          <p>
            ยกระดับธุรกิจของคุณสู่อีกขั้นด้วย Tailor-Made AI Solutions
            ที่ออกแบบให้ตอบโจทย์ธุรกิจของคุณ{' '}
            <span>และตรงกับทุกความต้องการ</span>
          </p>
        </div>

        <nav className='AI__hero__links'>
          <a
            href='#solutions'
            title='Explore Solutions'
            className='AI__hero__button'
            onClick={(e) => handleOnClick(e, 'Explore Solutions')}
          >
            <span>Explore Solutions</span>
          </a>
          <a
            href='#contact'
            title='Get a Quote'
            className='AI__hero__button'
            onClick={(e) => handleOnClick(e, 'Get a Quote')}
          >
            <span>Get a Quote</span>
          </a>
        </nav>
      </div>
    </div>
  )
}
